<template>
  <section>
    <MNavBar :current="4" />
    <section class="loading-container" v-if="pageLoading"></section>
    <section class="error-container" v-else-if="pageError"></section>
    <section class="content-container" v-else>
      <m-banner
        :coverImageUrl="bannerConfig.coverImageUrl"
        :backgroundColor="bannerConfig.backgroundColor"
        :title="bannerConfig.title"
        :subTitle="bannerConfig.subTitle"
        :description="bannerConfig.description"
      ></m-banner>
      <m-info :title="infoConfig.title" :detailList="infoConfig.detailList"></m-info>
      <m-product-list :productList="productList"></m-product-list>
      <m-sale-channel
        :title="saleChannelConfig.title"
        :saleChannelList="saleChannelConfig.saleChannelList"
        pageType="goods"
        frogPath="/click/ZebraAIGoods/buyNow"
      ></m-sale-channel>
    </section>
    <MFooter />
  </section>
</template>

<script>
import MBanner from '../../../components/mobile/MBanner.vue'
import MInfo from '../../../components/mobile/MInfo.vue'
import MProductList from '../../../components/mobile/MProductList.vue'
import MSaleChannel from '../../../components/mobile/MSaleChannel.vue'
import MNavBar from '../../../components/mobile/MNavBar.vue'
import MFooter from '../../../components/mobile/MFooter.vue'
import OperationService from '../../../service/operation'

export default {
  components: {
    MBanner,
    MInfo,
    MSaleChannel,
    MProductList,
    MNavBar,
    MFooter
  },
  data() {
    return {
      pageLoading: true,
      pageError: false,
      bannerConfig: {},
      infoConfig: {},
      productList: []
    }
  },
  created() {
    this.getDuringTime()
    this.initConfigData()
  },
  methods: {
    getDuringTime() {
      this.startTime = Date.now()
      window.addEventListener('pagehide', () => {
        const now = Date.now()
        const times = now - this.startTime
        this.sendEvent('/time/ZebraAIGoods/duration', [{ key: 'duration', value: times }])
      })
    },
    sendEvent(path, addParams = []) {
      const commonParams = [
        { key: 'devicetype', value: 'mobile' },
        { key: 'pageType', value: 'goods' }
      ]
      this.$addFrog(path, [...commonParams, ...addParams])
    },
    initConfigData() {
      this.pageLoading = true
      this.pageError = false
      OperationService.fetchToyConfig()
        .then((res) => {
          const { pageConfig } = res || {}
          const { bannerConfig, infoConfig, productList, saleChannelConfig } = pageConfig || {}
          this.bannerConfig = bannerConfig
          this.infoConfig = infoConfig
          this.productList = productList
          this.saleChannelConfig = saleChannelConfig
          this.pageLoading = false
        })
        .catch(() => {
          this.pageLoading = false
          this.pageError = true
        })
    }
  }
}
</script>

<style lang="less" scoped>
.loading-container,
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}
</style>
